<template>
  <div>
    <v-container class="pa-0" fluid>
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" md="4" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  Service Enquiry List
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="12">
            <v-card-text class="pt-0 pr-1 gap" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
              <v-checkbox v-if="!isBSKRoleUser" class="me-2" v-model="isTransport" @change="getRegistration()" label="Transport Opted" color="#5d58ef" hide-details></v-checkbox>
              <v-checkbox v-if="!isBSKRoleUser" class="me-2" v-model="managedByCenter" @change="getRegistration()" label="Transport Managed By Centre" color="#5d58ef" hide-details></v-checkbox>
              <v-checkbox v-if="!isBSKRoleUser" class="me-2" v-model="managedByVendor" @change="getRegistration()" label="Transport Managed By Vendor" color="#5d58ef" hide-details></v-checkbox>

              <v-text-field
                :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                v-model="search"
                @input="searchData"
                append-icon="mdi-magnify"
                class="ml-auto mb-2"
                label="Search"
                hide-details
                single-line
                style="max-width:350px;"
              />
              <v-btn v-if="!isBSKRoleUser" small elevation="1" @click="modalOk = true" :disabled="!this.franchiseeID" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
                <v-icon left>mdi-plus</v-icon>
                Add / Search enquiry
              </v-btn>
            </v-card-text>
          </v-col>
        </v-row>
        <v-divider class=" my-0 " />
        <div>
          <v-data-table sort-by hide-default-footer :items-per-page="-1" :headers="headers" :items="enquiryData" :search="search" item-key="index">
            <template v-slot:item.actions="{ item }" v-if="isWrite">
              <v-row justify="end">
                <v-col>
                  <router-link color="success" :to="{ name: 'editServiceEnquiry', params: { enquiryCodeProp: item.enquiryCode } }">
                    <v-btn x-small outlined class="px-2 ml-1 dark ma-1" color="success" min-width="0">
                      Edit Service Enquiry
                    </v-btn>
                  </router-link>
                  <router-link
                    class="px-2 ml-1 ma-1"
                    :to="{
                      name: 'listAssignedServices',
                      params: { enquiryID: item.serviceRegistration.enquiryID, franchiseeID: item.serviceRegistration.franchisee.id, academicYearID: item.academicYearID }
                    }"
                    title="Assigned Service Plan"
                  >
                    <v-btn x-small class="px-2 ml-1 ma-1" outlined>View Assigned Service</v-btn>
                  </router-link>

                  <router-link
                    :to="{
                      name: 'assignServicePlan',
                      params: { enquiryID: item.serviceRegistration.enquiryID, franchiseeID: item.serviceRegistration.franchisee.id, academicYearID: item.academicYearID, isTransport: isTransport }
                    }"
                    v-if="item.franchiseeID"
                  >
                    <v-btn x-small class="px-2 ml-1 ma-1" color="darkblue" outlined>Assign Service</v-btn>
                  </router-link>
                  <router-link
                    :to="{ name: 'EditEnquiries', params: { endpointID: item.id, enquiryCode: item.enquiryCode, radio: radio, type: 'Service' } }"
                    :event="!item.enrollmentCode ? 'click' : ''"
                  >
                    <v-btn x-small outlined class="px-2 ml-1 dark ma-1" color="success" min-width="0">
                      Edit Admission Enquiry
                    </v-btn>
                  </router-link>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </div>
        <v-col v-if="enquiryData.length != 0">
          <v-row>
            <v-col cols="4" sm="3">
              <v-select v-model="pageSize" :items="pageSizes" label="Items per Page" @change="handlePageSizeChange"></v-select>
            </v-col>
            <v-col cols="12" sm="9">
              <v-pagination v-model="page" :length="totalPages" :total-visible="10" @input="handlePageChange"></v-pagination>
            </v-col>
          </v-row>
        </v-col>
      </v-card>
    </v-container>

    <v-dialog
      persistent
      v-model="modalOk"
      max-width="1100"
      :active="modalOk"
      :on-cancel="
        () => {
          ;(modalOk = false), clearData()
        }
      "
    >
      <form @submit.prevent="studEnquiry">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title>Enquiry</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="
                  () => {
                    ;(modalOk = false), clearData()
                  }
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="5">
                <b-autocomplete
                  v-model="searchKey"
                  placeholder="Search Mobile No. , Enquiry Code, Enrollment Code."
                  @input="searchKey.length === 6 ? studEnquiry() : false"
                  @select="selectEvent"
                  :data="findDataArr"
                  field="fatherMobile"
                >
                </b-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-btn elevation="1" color="success" type="submit"><v-icon left>mdi-magnify</v-icon> Search</v-btn>
              </v-col>
              <v-col cols="12" sm="4">
                <v-btn elevation="1" color="success" :to="{ name: 'addServiceEnquiry' }"><v-icon left>mdi-plus</v-icon>Add New Enquiry</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-data-table v-if="findDataArr.length > 0" disable-pagination :hide-default-footer="true" :headers="stdEnqModalHeaders" :items="findDataArr">
                <template v-slot:item.enquiryCode="{ item }"> {{ item.enquiryCode || '-' }} / {{ item.franchisee.companyName || item.franchisee.companyName || '-' }} </template>
                <template v-slot:item.createdAt="{ item }">{{ item.dateOfEnquiry }}</template>
                <template v-slot:item.studentFirstName="{ item }">
                  <span>{{ item.studentFirstName || '-' }}</span>
                </template>
                <template v-slot:item.fatherName="{ item }">
                  <span>{{ item.fatherName || '-' }}</span>
                </template>
                <template v-slot:item.fatherMobile="{ item }">
                  <span>{{ item.fatherMobile || '-' }}</span>
                </template>

                <template v-slot:item.actions="{ item }">
                  <router-link color="success" :to="{ name: 'editServiceEnquiry', params: { enquiryCodeProp: item.enquiryCode } }">
                    <v-btn x-small outlined class="px-2 ml-1 dark ma-1" color="success" min-width="0">
                      Edit Service Enquiry
                    </v-btn>
                  </router-link>
                </template>
                <template v-slot:no-data>
                  <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
                </template>
              </v-data-table>
            </v-row>
          </v-card-text></v-card
        >
      </form>
    </v-dialog>
    <component :is="isCompo" :enquiryID="enquiryIDD" :franchiseeID="franchiseeID" :academicYearID="academicYearID"> </component>
  </div>
</template>
<script>
import stores from '@/stores'
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
import Utils from '@/utils'
import { mapGetters } from 'vuex'

export default {
  name: 'registration',
  props: ['radio2'],
  components: {
    MaterialCard
  },
  data () {
    return {
      STUDENT_DATA: {},
      modalOk: false,
      search: '',
      headers: [
        { text: 'Student Name', sortable: true, value: 'studentFirstName' },
        { text: 'Enquiry Code', value: 'enquiryCode', sortable: true },
        { text: 'Enrollment Code', value: 'studentEnrollment.enrollmentCode', sortable: true },
        { text: 'Class', value: 'serviceRegistration.studentClass.name', sortable: true },
        { text: 'Parent Mobile Number', value: 'fatherMobile', sortable: true },
        { text: 'Service Franchiess', value: 'serviceRegistration.franchisee.companyName', sortable: true },
        { text: 'Email', value: 'fatherEmailID', sortable: true }
      ],
      stdEnqModalHeaders: [
        { text: 'Sr No', value: 'srno', sortable: true },
        { text: 'Enquiry Code', value: 'enquiryCode', sortable: true },
        { text: 'Enrollment Code', value: 'enrollmentCode', sortable: true },
        { text: 'Enquiry Date', value: 'createdAt', sortable: true },
        { text: 'Student Name', value: 'studentFirstName', sortable: true },
        { text: 'Parent Name', value: 'fatherName', sortable: true },
        { text: 'Parent Mobile Number', value: 'fatherMobile', sortable: true },
        { text: 'Action', value: 'actions', align: 'center' }
      ],
      planAssignModal: false,
      sendLinkDialogOffline: false,
      isTransport: false,
      enquiryIDD: '',
      isWrite: false,
      filterData: [],
      searchTerm: '',
      radio: 'all',
      total: 0,
      sendLinkDialog: false,
      isLoading: false,
      loadingComponent: null,
      enableDocumentModal: false,
      enableSectionModal: false,
      enableSectionModalOffline: false,
      enquiryData: [],
      franchiseeID: '',
      hasClicked: false,
      sectionID: '',
      classID: '',
      selectedclassID: '',
      selectedclassName: '',
      selectedEnquiryCode: '',
      academicYearID: '',
      isCompo: null,
      filter: {
        fromDate: moment()
          .subtract(1, 'month')
          .format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        academicYearID: '',
        stage: 'All'
      },
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      stages: [],
      searchEnquiryObj: {
        academicYearID: '',
        searchType: 'studentmobile',
        searchKey: ''
      },
      studentPhotoURL: '',
      fatherPhotoURL: '',
      motherPhotoURL: '',
      birthCertificateURL: '',
      transferCertificateURL: '',
      immunisationCertificateURL: '',
      studentAadharCardURL: '',
      fatherAadharCardURL: '',
      motherAadharCardURL: '',
      healthCertificateURL: '',
      isDataLoaded: false,
      documentData: [],
      registrationData: [],
      classes: [],
      sections: [],
      searchDialog: false,
      searchKey: '',
      findDataArr: [],
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 50, 100],
      isBSKRoleUser: false
    }
  },
  mounted: async function () {
    // await this.getRegistration()
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
      await this.academics()
      await this.getRegistration()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
      await this.academics()
      this.page = 1
      await this.getRegistration()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
      await this.academics()
      this.page = 1
      await this.getRegistration()
    },
    sendLinkDialog: function (val) {
      if (val === false) {
        this.sectionID = ''
      }
    },
    sendLinkDialogOffline: function (val) {
      if (val === false) {
        this.sectionID = ''
      }
    }
  },
  async created () {
    await this.getUserRolesFromIndexDB()
    if (!this.isBSKRoleUser) {
      this.headers.push({ text: 'Action', value: 'actions', align: 'center', sortable: false })
    }
    await this.getRegistration()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    try {
      this.isLoading = true
      const { data: questions } = await http.get(`${constants.API_URL}/api/enquiry-questions`)
      this.stages = questions.filter(obj => obj.type === 'INTEREST_TYPE')
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find(y => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.academicYearID = academicYear ? academicYear.id : ''
      this.isLoading = false
      this.onFranchiseeChange()
      const studentclasses = await http.get(`${constants.API_URL}/api/students/class`)
      this.classes = studentclasses.data.rows
    } catch (e) {
      this.isLoading = false
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }

    if (this.radio2) {
      this.radio = this.radio2
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    getUserRolesFromIndexDB: function () {
      this.isBSKRoleUser = false
      if (stores.user.roles) {
        let obj = stores.user.roles
        obj.forEach(item => {
          if (item.role === constants.BSK_ROLE_NAME) {
            this.isBSKRoleUser = true
          }
        })
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },
    studEnquiry: async function () {
      if (this.searchKey.length > 3) {
        try {
          let data = await http.get(`${constants.API_URL}/api/service/registration-by-mobile?mobile=${this.searchKey}`)
          this.findDataArr = data.data

          // console.log(this.findDataArr, 'MyData')
          this.findDataArr.forEach((e, i) => {
            e.srno = i + 1
          })
          this.findDataArr.forEach((e, i) => {
            e.dateOfEnquiry = e.dateOfEnquiry ? moment(e.dateOfEnquiry).format('D-MMM-YYYY HH:mm') : '-'
          })
          // console.log(this.findDataArr, 'findDataArr')
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(`${errorMessage}, Kindly create new!`)
          // this.$router.push({ name: 'addServiceEnquiry', params: { newMobileProp: this.searchKey } })
        } finally {
        }
      } else {
        this.errMsg('Kindly enter more than 3 digit number or enquiry ID or enrollment code')
      }
    },

    selectEvent (e) {
      this.$router.push({ name: 'editServiceEnquiry', params: { enquiryCodeProp: e.enquiryCode } })
    },
    getRegistration: async function () {
      try {
        this.isLoading = true
        const paramData = {}
        if (this.franchiseeID && this.academicYear) {
          paramData.franchiseeID = this.franchiseeID
          paramData.academicYearID = this.academicYear ? this.academicYear.id : this.academicYearID
        }
        paramData.page = this.page - 1
        paramData.size = this.pageSize
        paramData.search = this.search
        paramData.isTransport = this.isTransport
        paramData.managedByVendor = this.managedByVendor
        paramData.managedByCenter = this.managedByCenter
        const response = await http.get(`${constants.API_URL}/api/service/registration`, {
          params: paramData
        })
        this.enquiryData = response.data.rows
        this.totalPages = response.data.totalPages
        this.searchTerm = null
        this.total = this.enquiryData.length
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    clearData () {
      this.searchKey = ''
      this.findDataArr = []
    },
    handlePageChange (value) {
      this.page = value
      this.getRegistration()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getRegistration()
    },
    searchData () {
      if (this.search) {
        this.page = 1
        this.getRegistration()
      } else {
        this.page = 1
        this.getRegistration()
      }
    },
    getYearIn: function () {
      this.academicYears.find(obj => {
        if (obj.id === this.filter.academicYearID) {
          this.Year = Number(obj.academicYear.split('-')[0])
        }
      })
    },
    academics: async function () {
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find(y => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.academicYearID = academicYear ? academicYear.id : ''
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.gap {
  gap: 15px
}
</style>
